/**
 * Uploader
 * 
 * @Author: Focci
 * @Date: 2023-08-16 16:00:40
 * @Last Modified by: Focci
 * @Last Modified time: 2023-08-16 16:00:40
 */

import PropTypes from 'prop-types'
import UploadCard from '@comp/upload/UploadCard'
import { useEffect } from 'react'

export default function Uploader({
  data = {},
  onClose = () => {},
  uploadCallback = () => {},
  children,
}) {
  useEffect(() => {
    if(data.status !== 'pending') {
      return () => {}
    }
    
    const controller = new AbortController()
    uploadCallback(data, controller)

    return () => controller.abort()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <UploadCard
      loading={data.status === 'uploading'}
      src={data.url}
      onClose={onClose}
    >
      {children}
    </UploadCard>
  )
}

Uploader.propTypes = {
  data: PropTypes.object,
  onClose: PropTypes.func,
  uploadCallback: PropTypes.func,
  children: PropTypes.node,
}
